import {
  User,
  Briefcase,
  Code,
  GraduationCap,
  Award,
  Trophy,
  type LucideIcon,
} from 'lucide-react';
import type { SiteContent } from '@personal-portfolio/contract';

// Paths and icons are structural and stay static; the visible label is
// editorial, so render sites resolve `titleKey` against
// useSiteContent().nav.
export interface NavigationItem {
  titleKey: keyof SiteContent['nav'];
  path: string;
  icon: LucideIcon;
}

export const navigationItems: NavigationItem[] = [
  {
    titleKey: 'about',
    path: '/about',
    icon: User,
  },
  {
    titleKey: 'experience',
    path: '/experience',
    icon: Briefcase,
  },
  {
    titleKey: 'projects',
    path: '/projects',
    icon: Code,
  },
  {
    titleKey: 'education',
    path: '/education',
    icon: GraduationCap,
  },
  {
    titleKey: 'certifications',
    path: '/certifications',
    icon: Award,
  },
  {
    titleKey: 'awards',
    path: '/awards',
    icon: Trophy,
  },
];
